import { useEffect, useState } from 'react';

export const LOADER_REVEAL_DELAY = 1000;

// Each pending operation owns its mounted indicator. Quick completions unmount
// it before any graphic or media decoder is created.
export function useDelayedReveal(delay = LOADER_REVEAL_DELAY) {
  const milliseconds = Math.max(0, delay);
  const [visible, setVisible] = useState(milliseconds === 0);
  useEffect(() => {
    if (visible) return undefined;
    const timer = setTimeout(() => setVisible(true), milliseconds);
    return () => clearTimeout(timer);
  }, [milliseconds, visible]);
  return visible;
}
